import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { MainLayout } from 'register-partners-js/react/components/layouts/main';

export default class NatureOfOpsRoute extends Route {
  mainLayout = MainLayout;

  @service router;

  async model() {
    let registration = this.modelFor('registration');
    let organization = await registration.get('organization');
    return { organization, registration };
  }
}
